<template>
  <div class="product-details">
    <div class="title">
      {{ title }}产品明细
    </div>
    <div class="row">
      <div class="address-content">
        <span>配送至：</span>
        <div v-if="address.receiverName" class="adressBox">
          <div v-if="address.isDefault" class="defTab">
            默认
          </div>
          <div class="item">
            {{ address.province }}
          </div>
          <div class="item">
            {{ address.city }}
          </div>
          <div class="item">
            {{ address.county }}
          </div>
          <div class="item">
            {{ address.receiptAddress }}
          </div>
          <div class="item">
            {{ address.receiverName }}
          </div>
          <div class="item">
            {{ address.receiverPhone }}
          </div>
        </div>
        <div v-else class="adressBox">
          -
        </div>
        <el-button
          type="text"
          style="padding: 0; margin-left: 15px"
          @click.stop="showAddress = true"
        >
          更改地址
        </el-button>
      </div>
      <div class="select-box">
        <el-date-picker
          v-model="deliverTimeValue"
          type="date"
          :picker-options="{
            disabledDate(time) {
              return time.getTime() < Date.now()
            }
          }"
          placeholder="批量修改变更客期"
          :disabled="isDisabled || title === '价外费用合同'"
        />
        <el-select
          v-model="freightPropertiesValue"
          placeholder="请选择货运属性"
          :disabled="isDisabled || title === '价外费用合同'"
          style="marginLeft: 18px"
        >
          <el-option
            v-for="(value, key) in freightProperty"
            :key="key"
            :label="value"
            :value="key"
          />
        </el-select>
        <el-button
          type="primary"
          size="mini"
          class="ml-18 btn-setting"
          :class="{ 'btn-disabled': isDisabled }"
          :disabled="isDisabled || title === '价外费用合同'"
          @click="setDeliverTime"
        >
          批量设置
        </el-button>
        <el-button
          type="default"
          size="mini"
          class="ml-18 btn-setting"
          :class="{ 'btn-disabled': isDisabled }"
          :disabled="isDisabled || title === '价外费用合同'"
          @click="setSingleMaterialNum()"
        >
          设置料号
        </el-button>
      </div>
    </div>
    <div class="table-box">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        tooltip-effect="dark"
        style="width: 100%"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="left" width="55" />
        <el-table-column
          prop="productCode"
          label="销售产品代码"
          align="left"
        />
        <el-table-column prop="productName" label="产品型号" align="left" />
        <el-table-column
          prop="materialNum"
          label="料号"
          align="left"
          width="160px"
        >
          <template slot-scope="scope">
            <el-button
              v-if="title !== '价外费用合同'"
              type="text"
              @click="setSingleMaterialNum(scope.row, scope.$index)"
            >
              {{ scope.row.materialNum ? scope.row.materialNum : "选择料号" }}
            </el-button>
            <span v-else>{{ scope.row.materialNum }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="productNum"
          label="数量"
          align="left"
          width="150px"
        />
        <el-table-column prop="materialUnit" label="单位" align="left" />
        <el-table-column
          prop="beforeSplitPrice"
          label="拆分前单价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productPriceAdd"
          label="拆分前总价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productActualPrice"
          label="实际结算单价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productActualPriceAdd"
          label="实际结算总价"
          align="right"
          header-align="left"
        />
        <el-table-column
          v-if="title !== '价外费用合同'"
          prop="borrowToSaleFlg"
          label="测试借条转订单"
          align="left"
        >
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.borrowToSaleFlg"
              @change="handleTestOrderConversionChange($event, scope.$index)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="freightProperties"
          label="货运属性"
          align="left"
          width="160px"
        >
          <template v-slot="{row}">
            <el-select
              v-model="row.freightProperties"
              placeholder="请选择"
            >
              <el-option
                v-for="(value, key) in freightProperty"
                :key="key"
                :label="value"
                :value="key"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          v-if="title !== '价外费用合同'"
          prop="freightProperties"
          label="电源线规格"
          align="left"
          width="160px"
        >
          <template v-slot="{row}">
            <el-input
              v-model="row.powerCord"
              disabled
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="expectedDeliveryDate"
          label="期望发货日期"
          align="left"
          width="160px"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.expectedDeliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="{
                disabledDate(time) {
                  return time.getTime() < Date.now()
                }
              }"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="taxRate"
          label="税率"
          align="right"
          header-align="left"
          width="150px"
        >
          <template v-slot="{row}">
            <el-select
              v-model="row.taxRate"
              placeholder="请选择"
              @focus="changeSelectTaxRate"
            >
              <el-option
                v-for="(item,index) in taxRateBySupplyData"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="serviceDesc" label="服务备注" align="left">
          <template slot-scope="scope">
            {{ scope.row.serviceDesc || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="productRemark" label="备注" align="left">
          <template slot-scope="scope">
            {{ scope.row.productRemark || "-" }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 料号 -->
    <material-num ref="MaterialNum" @chooseMateria="chooseMateria" />
    <address-box
      :prop-open.sync="showAddress"
      @chooseAddress="changeAddress"
      @ChangeDatas="ChangeDatas"
    />
  </div>
</template>
<script>
import { Message } from 'element-ui';
import addressBox from '@/views/address/index.vue';
import MaterialNum from '@/views/contractCommonInput/MaterialNum.vue';
import { getReceiptAddressInfoModel } from '@/API';
import { getTaxRateBySupplyUnitCode } from '@/API/international';
import { mapState } from 'vuex';
export default {
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      default: () => []
    },
    address: {
      type: Object,
      default: () => {}
    },
    // 输入框绑定字段
    formDataDetail: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      multipleSelection: [],
      deliverTimeValue: '',
      freightPropertiesValue: '',
      taxRateBySupplyData: [], // 税率下拉框
      freightPropertiesList: [{
        value: '直发',
        label: '直发'
      }, {
        value: '不发货有回执',
        label: '不发货有回执'
      }, {
        value: '不发货无回执',
        label: '不发货无回执'
      }, {
        value: '供应商直发',
        label: '供应商直发'
      }, {
        value: '软件订单',
        label: '软件订单'
      }],
      showAddress: false
    };
  },
  components: {
    MaterialNum,
    addressBox
  },
  computed: {
    // 货运属性数据配置
    ...mapState({
      freightProperty: state => state.enumeration.freightProperty
    }),
    // 判断设置按钮和下拉框是否可操作
    isDisabled () {
      if (this.multipleSelection.length < 2) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    changeAddress (val) {
      // 选择其他地址
      this.$emit('changeAddress', val);
      this.showAddress = false;
    },
    ChangeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (!json.data.isDelete) {
              this.address = json.data;
            } else {
              this.address = {};
            }
          }
        }).catch(() => {

        });
      }
    },
    handleTestOrderConversionChange (val, index) {
      // 产品行上的货运属性, val ? 货运属性编码Code : ''
      this.$set(this.tableData[index], 'freightProperties', val ? '20' : '');
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    // 合计函数
    getSummaries (params) {
      const { columns, data } = params;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const noSumList = [1, 2, 3, 5, 6, 8, 10, 11, 12, 13, 14, 15];
        if (noSumList.includes(index)) {
          sums[index] = '';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          });
          sums[index] += '';
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    // 设置单个料号
    setSingleMaterialNum (row, index) {
      if (!this.formDataDetail.postOrdetypeName) {
        this.$notify.error({ message: '请先选择订单类型' });
        return;
      }

      let productAndMaterialGroup = [];
      let MaterialNumValues = {};
      if (!row) {
        this.tableData.forEach((item, index) => {
          if (item.productCode) {
            productAndMaterialGroup.push({
              productSalesCode: item.productCode, // 产品销售代码
              productName: item.productName, // 产品名称
              productNum: item.productNum, // 购买数量
              exclusiveMaterial: item.materialNumberId || '', // 料号
              isHavePowerCord: item.isHavePowerCord || false, // 是否有电源线
              powerCordSpecification: item.powerCord || null, // 电源线规格
              isTestOrder: item.borrowToSaleFlg || false // 是否是测试借条转订单

            });
            MaterialNumValues[item.productCode] = {
              materialNumberId: item.materialNumberId,
              materialUnit: item.materialUnit
            };
          }
        });
      } else {
        if (row.productCode) {
          productAndMaterialGroup.push({
            productSalesCode: row.productCode, // 产品销售代码
            productNum: row.productNum, // 产品购买数量
            productName: row.productName, // M6000-16GT8SFP2XS 产品名称
            exclusiveMaterial: row.materialNum, // 料号
            isHavePowerCord: row.hasPowerCord || false, // 是否有电源线
            powerCordSpecification: row.powerCord || null, // 电源线规格
            isTestOrder: row.borrowToSaleFlg || false // 是否是测试借条转订单

          });
          MaterialNumValues[row.productCode] = {
            materialNumberId: row.materialNum,
            materialUnit: row.materialUnit
          };
        } else {
          return;
        }
      }
      console.info('选择料号打开弹窗的入参-----', row);
      let param = {
        orderType: this.form.orderType, // 合同类型
        orderUnit: this.form.crmAccountName, //, 订货单位
        soldCountry: this.form.salesArea, // 销往国家
        contractName: this.form.projectName, // 项目名称
        contractNumber: this.form.oldContractNum, // 原合同编号
        contractType: this.formDataDetail.postOrdetypeName || '', // 订单类型
        materialReqProductVOS: productAndMaterialGroup
      };

      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },
    // 选择料号回调
    chooseMateria ({ list, RowIndex }) {
      // 设置表单值
      let setTableProps = (RowIndex, data) => {
        this.tableData[RowIndex].materialNum = data.selected;
        this.tableData[RowIndex].materialUnit = data.materialUnit;
      };

      // 判断是否是设置单个料号
      if (RowIndex === 'all') {
        list.forEach((data, index) => {
          let row = this.tableData[index];
          if (row.productCode === data.productSalesCode) {
            setTableProps(index, data);
          }
        });
      } else {
        setTableProps(RowIndex, list[0]);
      }
    },
    // 批量设置发货日期
    setDeliverTime () {
      if (!this.deliverTimeValue && !this.freightPropertiesValue) {
        return Message.info('请选择期望发货时间、货运属性');
      }
      this.multipleSelection.forEach(item => {
        item.expectedDeliveryDate = this.deliverTimeValue ? this.deliverTimeValue : item.expectedDeliveryDate;
        item.freightProperties = this.freightPropertiesValue ? this.freightPropertiesValue : item.freightProperties;
      });
      this.deliverTimeValue = '';
      this.freightPropertiesValue = '';
      this.$refs.multipleTable.clearSelection();
    },
    // 选择税率的change方法
    changeSelectTaxRate () {
      this.getTaxRateBySupplyUnitCodeMethods();
    },
    // 获取税率下拉选数据
    getTaxRateBySupplyUnitCodeMethods () {
      getTaxRateBySupplyUnitCode(this.form.supplyUnitCode).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.taxRateBySupplyData = json.data;
        }
      }).catch(() => {

      });
    }
  }

};
</script>
<style lang="scss" scoped>
.product-details {
  margin-top: 12px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  .title {
    color: #383838;
    font-size: 14px;
    font-weight: bold;
  }
  .row {
    margin-top: 12px;
    margin-bottom: 12px;
    font-size: 14px;
    .btn-setting {
      width: 90px;
      height: 30px;
      font-size: 14px;
    }
  }
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ml-18 {
  margin-left: 18px;
}
.btn-disabled {
  color: #b8b8b8;
  font-size: 14px;
  border-radius: 4px;
  background-color: rgba(245, 245, 245, 1);
  border: 1px solid #d9d9d9;
}
.table-box {
  ::v-deep .el-table__row td > .cell{
    overflow: visible;
  }
  ::v-deep .el-table__footer-wrapper {
    tbody {
      td.el-table__cell {
        background-color: transparent;
        font-weight: bold;
      }
    }
  }
  ::v-deep .el-table__row {
    .el-table__cell {
      .el-select,
      .el-date-editor {
        width: 130px;
      }
      .el-date-editor {
        .el-input__prefix {
          .el-icon-date {
            position: absolute;
            right: -122px;
          }
        }
      }
    }
  }
}
.row {
  .select-box {
    ::v-deep .el-date-editor {
      width: 270px;
      .el-icon-date {
        position: absolute;
        right: -262px;
      }
    }
  }
}

.product-details {
  ::v-deep .el-date-editor {
    .el-input__inner {
      padding-left: 10px;
    }
  }
}
.address-content {
  display: flex;
  margin-bottom: 10px;
  padding: 15px;
  background: #ebeef5;
  .adressBox {
    display: inline-block;
    .item {
      display: inline-block;
      margin-right: 6px;
    }
    .defTab {
      padding: 3px 10px;
      display: inline-block;
      background: #1b73ff;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      margin-right: 15px;
    }
  }
}
</style>
